import * as Yup from "yup";

export const registroSchema = Yup.object({
    nombre: Yup.string()
        .required("Campo requerido.")
        .min(2, "2 carateres mínimo.")
        .max(30, "30 caracteres méximo."),
    apellido: Yup.string()
        .required("Campo requerido.")
        .min(2, "2 caracteres mínimo.")
        .max(30, "30 caracteres máximo."),
    dni: Yup.number()
        .required("Campo requerido.")
        .min(8, "8 caracteres mínimo."),
    email: Yup.string()
        .required("Campo requerido.")
        .email("Correo electronico invalido.")
        .max(30, "30 caracteres máximo."),
    password: Yup.string()
        .required("Campo requerido.")
        .min(8, "8 caracteres mínimo."),
    codigo_de_area: Yup.number()
        .required("Campo requerido."),
    celular: Yup.number()
        .required("Campo requerido."),
    zonas: Yup.array()
        .required("Campo requerido."),
    servicios: Yup.array()
        .required("Campo requerido."),
})